import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './icon.scss';

export default function Icon() {
    return (Component) => {
        const WithIcon = (props) => {
            const {
                className,
                focusable,
                height,
                size,
                width,
                ...other
            } = props;
            const iconHeight = height || size;
            const iconWidth = width || size;
            const iconClassName = classNames('icon', className);

            return (
                <Component
                    className={iconClassName}
                    focusable={`${focusable}`}
                    height={iconHeight}
                    width={iconWidth}
                    {...other}
                />
            );
        };

        WithIcon.propTypes = {
            className: PropTypes.string,
            focusable: PropTypes.bool,
            height: PropTypes.number,
            role: PropTypes.string,
            size: PropTypes.number,
            width: PropTypes.number,
        };

        WithIcon.defaultProps = {
            className: '',
            focusable: false,
            height: null,
            role: 'presentation',
            size: 14,
            width: null,
        };

        return WithIcon;
    };
}
